import history from "history/browser";
import {useCallback} from 'react';
import {useAppContext} from "./useAppContext";

/**
 * A hook that returns the current hash and a function to set the hash
 * @returns {{hash: function, update: function}}
 */
export const useHash = (): { hash: () => string; update: (newHash: string) => void; } => {
    const {productId, primaryId} = useAppContext();

    const updateHash = useCallback((newHash: string) => {
        // Append a '#' to the new hash if it doesn't already have one.
        if (!newHash.startsWith('#')) newHash = `#${newHash}`;

        // If the new hash is the same as the current hash, then don't update the history.
        if (newHash === history.location.hash) return;

        // Push the new hash to the history with the current productId and primaryId.
        history.push(`${history.location.pathname}${history.location.search}${newHash}`, {productId, primaryId});
    }, [productId, primaryId]);

    return {
        hash: () => history.location.hash,
        update: updateHash
    }
};